export interface ChatMessage {
  role: 'system' | 'user' | 'assistant';
  content: string;
}

export enum AppState {
  IDLE = 'IDLE',
  ANALYZING = 'ANALYZING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface VisionRequestPayload {
  model: string;
  messages: {
    role: string;
    content: (
      | { type: 'text'; text: string }
      | { type: 'image_url'; image_url: { url: string } }
    )[];
  }[];
  temperature: number;
  max_tokens: number;
  top_p: number;
  stream: boolean;
}

export interface GroqResponse {
  choices: {
    message: {
      content: string;
    };
  }[];
  error?: {
    message: string;
  };
}

export interface GeneratedResult {
  filename: string;
  content: string;
  isError?: boolean;
}